<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑班组' : '新增班组'"
      width="1000px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div v-if="loaded">
          <e-form ref="refForm1" :column="formColumn" :data.sync="selfData" />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗-绑定成员 -->
    <PopupBindChengYuan
      v-if="isShowPopupBindChengYuan"
      :show.sync="isShowPopupBindChengYuan"
      :list="selfData.cheng_yuan_list"
      @success="popupBindChengYuanSuccess"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupBindChengYuan: () => import('./popup-bind-cheng-yuan')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      selfData: {
        id: '',
        code: '',
        name: '',
        che_jian: '',
        chan_xian: '',
        cheng_yuan_list: [],
        miao_shu: '',
        status: true
      },
      formColumn: [
        {
          type: 'text',
          title: '班组编码',
          field: 'code',
          disabled: true,
          placeholder: '自动生成'
        },
        {
          type: 'text',
          title: '班组名称',
          field: 'name'
        },
        {
          type: 'select',
          title: '所属车间',
          field: 'che_jian',
          options: []
        },
        {
          type: 'select',
          title: '所属产线',
          field: 'chan_xian',
          options: []
        },
        {
          type: 'button',
          title: '班组成员',
          placeholder: '绑定',
          icon: 'vxe-icon-link',
          isError: true,
          fnChange: () => {
            this.isShowPopupBindChengYuan = true
          },
          width: '100%'
        },
        {
          type: 'textarea',
          title: '班组描述',
          field: 'miao_shu',
          width: '100%'
        },
        {
          type: 'switch',
          title: '状态',
          field: 'status'
        }
      ],
      isShowPopupBindChengYuan: false
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    selfData: {
      handler(val) {
        this.formColumn.forEach((item) => {
          if (item.title.includes('班组成员')) {
            let len = val.cheng_yuan_list.length
            item.isError = !len
            item.placeholder = `绑定(${len})`
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getChejianData()
    this.getChanxianData()
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.initSelfData()
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/banzu/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.form_data)
          this.selfData = result
        }
      })
      this.loaded = true
    },
    // 初始化数据
    initSelfData() {
      this.loaded = false
      this.loaded = true
    },
    // 绑定班组成员-成功
    popupBindChengYuanSuccess(data) {
      this.selfData.cheng_yuan_list = data
    },
    // 获取数据列表
    getChejianData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/columnData/list',
        data: {
          type: '车间',
          sortData: {
            id: 'desc'
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.list.map((item) => {
              return {
                key: item.name,
                val: item.name
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'che_jian') {
                item.options = result
              }
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 获取产线列表
    getChanxianData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/columnData/list',
        data: {
          type: '产线',
          sortData: {
            id: 'desc'
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.list.map((item) => {
              return {
                key: item.name,
                val: item.name
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'chan_xian') {
                item.options = result
              }
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/banzu/saveOrUpdate',
        data: {
          form_data: this.$util.deepCopy(this.selfData)
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.popupCancel()
            this.$emit('success')
            this.$message.success('保存成功')
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
